import script from "./promotionTimeControl.vue?vue&type=script&lang=ts&setup=true"
export * from "./promotionTimeControl.vue?vue&type=script&lang=ts&setup=true"

import "./promotionTimeControl.vue?vue&type=style&index=0&id=42aff472&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42aff472"]])

export default __exports__